// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__Evbmz","button":"profile_button__1y7Gz"};